import React from "react";
import { Link } from "react-router-dom";

const NotFound = () => (
  <div className="not-found">
    <Link to="/" className="link-home">
      Go back to dashboard
    </Link>
    <img
      style={{ width: "100%" }}
      src="https://media.istockphoto.com/id/943289962/vector/404-page-not-found-concept-vector-design-element.jpg?b=1&s=612x612&w=0&k=20&c=jtcU_Xr2dFemvLbdFe6T18N4tInBbNgF48nTTO8gk8g="
      alt="not-found"
    />
  </div>
);

export default NotFound;
